import { gql, useMutation } from '@apollo/client';
import { fetchAndActivate, getString } from 'firebase/remote-config';
import { useCallback } from 'react';
import { remoteConfig } from '../client/firebase';

const GET_CURRENT_STUDENT_EXPERIMENT = gql`
  mutation GetCurrentStudentExperiment {
    getCurrentStudentExperiment {
      state
      canReturnToOldVersion
      customToken
    }
  }`;

const UPDATE_USER_EXPERIMENT_STATE = gql`
  mutation UpdateUserExperimentState {
     updateUserExperimentState
  }`;

export interface StudentExperiment {
  state: 'react' | 'flutter',
  canReturnToOldVersion: boolean,
  customToken: string,
}

interface GetCurrentStudentExperimentOutput {
  getCurrentStudentExperiment: StudentExperiment,
}

export function useStudentExperiment() {
  const [update] = useMutation(UPDATE_USER_EXPERIMENT_STATE);
  const [get] = useMutation<GetCurrentStudentExperimentOutput>(GET_CURRENT_STUDENT_EXPERIMENT);

  const updateUserExperimentState = useCallback(async () => {
    await update();
  }, [update]);

  const getExperiment = useCallback(async (): Promise<StudentExperiment> => {
    const res = await get();

    if (res.data) {
      await fetchAndActivate(remoteConfig);
      const forceExperiment = getString(remoteConfig, 'force_experiment') as 'react' | 'flutter' | '';
      const studentExperiment = res.data?.getCurrentStudentExperiment;

      if (forceExperiment !== '') {
        return {
          state: forceExperiment,
          canReturnToOldVersion: false,
          customToken: studentExperiment.customToken,
        };
      }

      return studentExperiment;
    }
    throw new Error('Erro ao getCurrentStudentExperiment!');
  }, [get]);

  return {
    updateUserExperimentState,
    getExperiment,
  };
}
